/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Task_Assigned_ActionInputs */

const en_email_task_assigned_action = /** @type {(inputs: Email_Task_Assigned_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open task`)
};

const pt_br2_email_task_assigned_action = /** @type {(inputs: Email_Task_Assigned_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir atividade`)
};

/**
* | output |
* | --- |
* | "Open task" |
*
* @param {Email_Task_Assigned_ActionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const email_task_assigned_action = /** @type {((inputs?: Email_Task_Assigned_ActionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Task_Assigned_ActionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_email_task_assigned_action(inputs)
	return pt_br2_email_task_assigned_action(inputs)
});